import packageInfo from '../../package.json';

export const APP_VERSION = packageInfo.version;
